<tgrid-report-header [report]="report()"></tgrid-report-header>

<mat-card class="chart-section">
  <div class="chart-title">
    @let row = asyncExpandedRow | async;
    <span>
      {{ row?.countyName }} county | {{ row?.startDate?.toDate() | date: 'shortDate' }}
    </span>
  </div>
  <div #chart class="chart"></div>
  @let expandedRow = asyncExpandedRow | async;
  @if (!expandedRow) {
    <div class="chart-mask">
      <div>Select a metric to view related curve data</div>
    </div>
  }
</mat-card>


<div class="filter-bar">
  <h3>Select a row to view related curve data</h3>

  <form [formGroup]="filterGroup">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="year-selector">
      <mat-label>Select year</mat-label>
      <mat-select formControlName="year">
        <mat-option [value]="2025">2025</mat-option>
        <mat-option [value]="2024">2024</mat-option>
        <mat-option [value]="2023">2023</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Type to filter by county...</mat-label>
      <vulcan-icon class="filter-prefix" matPrefix icon="funnel-simple"></vulcan-icon>
      <input matInput formControlName="countyName">
    </mat-form-field>
  </form>
</div>

<table mat-table multiTemplateDataRows [dataSource]="dataSource"
       matSort matSortActive="peak_time" matSortDisableClear matSortDirection="desc">

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;" (click)="toggleRow(row)" class="clickable"
      [class.selected-row]="row === (asyncExpandedRow | async)"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-row"
      [class.selected-row]="row === (asyncExpandedRow | async)"></tr>


  <ng-container matColumnDef="county">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
    <td mat-cell *matCellDef="let row">{{ row.countyName }}</td>
  </ng-container>


  <ng-container matColumnDef="weather_event">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Weather Events</th>
    <td mat-cell #phenomList *matCellDef="let row" class="ellipsis phenom-list"
        [matTooltip]="row.phenomNames()"
        [matTooltipDisabled]="!hasEllipsis(phenomList)">
      <span>{{ row.phenomNames() || 'Not Available' }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="start_time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
    <td mat-cell *matCellDef="let row">{{ row.startDate.toDate() | date: 'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="end_time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
    <td mat-cell *matCellDef="let row">{{ row.endDate.toDate() | date: 'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="peak_time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Peak Time</th>
    <td mat-cell *matCellDef="let row">{{ row.peakTime.toDate() | date: 'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="event_duration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Duration (min)</th>
    <td mat-cell *matCellDef="let row">{{ row.eventDuration | number }}</td>
  </ng-container>


  <ng-container matColumnDef="impact_level">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Customers Impacted</th>
    <td mat-cell *matCellDef="let row">{{ row.impactLevel | number }}</td>
  </ng-container>

  <ng-container matColumnDef="auc">
    <th mat-header-cell *matHeaderCellDef>Area Under Curve</th>
    <td mat-cell *matCellDef="let row">{{ row.auc | number }}</td>
  </ng-container>


  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columns.length">
      <div class="hide" [class.show]="element === (asyncExpandedRow | async)">
        @if (element === (asyncExpandedRow | async)) {
          <tgrid-restoration-curve-table [curves]="(asyncExpandedRow | async)?.restorationCurves">
          </tgrid-restoration-curve-table>
        }
      </div>
    </td>
  </ng-container>


</table>
<mat-paginator pageSize="10" [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of metrics"></mat-paginator>
@if (report()) {
  <a class="attribution-link" target="_blank"
     [href]="report().attributionUrl">{{ report().attributionTitle || 'N/A' }}</a>
}

